import { filterValuesTypes } from 'consts'
import { useEffect } from 'react'

interface useInitProps {
  setValue: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
      props.setValue('type', filterValuesTypes[0])
  }, [])
}

export default useInit
